// Carica Fancybox e Vimeo da CDN (se non usi un bundler)
import { Fancybox } from "@fancyapps/ui";

// Carica l'API Vimeo se non presente
if (typeof Vimeo === 'undefined') {
    var vimeoScript = document.createElement('script');
    vimeoScript.src = "https://player.vimeo.com/api/player.js";
    document.head.appendChild(vimeoScript);
}

jQuery(document).ready(function($) {
    // Funzione per rilevare dispositivo mobile
    function isMobileDevice() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    }

    $('.custom-video').each(function() {
        var $wrapper = $(this);
        var videoId = $wrapper.data('video-url');
        var playerType = $wrapper.data('player-type');
        var controls = $wrapper.data('controls') === 1;
        var loop = $wrapper.data('loop') === 1;
        var highQuality = $wrapper.data('high-quality') === 1;
        var muted = isMobileDevice() ? true : ($wrapper.data('muted') === 1);
        var showMute = isMobileDevice() ? true : ($wrapper.data('show-mute') === 1);
        var autoStart = $wrapper.data('auto-start') === 1;
        var aspectRatio = $wrapper.data('aspect'); // Leggi il rapporto dal data-aspect
        var $popupIcon = $wrapper.find('.popup-icon');

        function createPlayer(wrapper, videoId, enableControls = controls, startTime = 0) {
            var existingPlayer = wrapper.data('player-instance');
            if (existingPlayer) {
                return;
            }

            var iframeID = 'player_' + Math.random().toString(36).substr(2, 9);
            var container = wrapper.find('.video__container');

            container.css({
                'position': 'absolute',
                'top': '-70px',
                'left': '0',
                'width': '100%',
                'height': 'calc(100% + 140px)',
                'z-index': '20',
                'display': 'block',
                'padding': '0',
                'overflow': 'hidden'
            }).addClass('video__container--playing');

            var controlsValue = enableControls ? 1 : controls;
            var backgroundValue = enableControls ? 0 : (controls ? 0 : 1);
            var autoplayValue = isMobileDevice() && muted ? 1 : 0;
            var iframe = document.createElement('iframe');
            iframe.setAttribute('src', "https://player.vimeo.com/video/" + videoId + "?autoplay=" + autoplayValue + "&loop=" + (loop ? 1 : 0) + "&muted=" + (muted ? 1 : 0) + "&quality=720p&controls=" + controlsValue + "&background=" + backgroundValue);
            iframe.setAttribute('frameborder', '0');
            iframe.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
            iframe.setAttribute('allowfullscreen', '');
            iframe.setAttribute('id', iframeID);
            iframe.setAttribute('class', 'embed-responsive-item w-full h-full');

            container.empty().append(iframe);

            if (typeof Vimeo === 'undefined') {
                return;
            }

            var vimeoPlayer = new Vimeo.Player(iframeID);
            wrapper.data('player-instance', vimeoPlayer);
            wrapper.find('.video__overlay').show();

            vimeoPlayer.on('loaded', function() {
                if (highQuality) {
                    vimeoPlayer.setQuality('720p');
                }
                if (startTime > 0) {
                    vimeoPlayer.setCurrentTime(startTime).then(() => console.log('Tempo impostato a:', startTime)).catch(err => console.error('Errore impostazione tempo:', err));
                }
                showControls(wrapper);
                
                // Avvia automaticamente il video sui dispositivi mobili se muto
                if (isMobileDevice() && muted) {
                    vimeoPlayer.play().then(() => {
                        wrapper.find('.video__image-video').addClass('video__image-video--playing');
                        console.log('Video avviato automaticamente su dispositivo mobile');
                    }).catch(err => console.error('Errore avvio automatico:', err));
                }
            });
        }

        function showControls(wrapper) {
            if (showMute) {
                wrapper.find('.mute-toggle').removeClass('hidden').show();
            }
            wrapper.find('.popup-icon').removeClass('hidden').show();
        }
        

        function togglePlayer(wrapper) {
            var videoId = wrapper.data('video-url');
            var player = wrapper.data('player-instance');

            if (!videoId) {
                return;
            }

            if (!player) {
                createPlayer(wrapper, videoId);
            } else {
                player.getPaused().then(function(paused) {
                    if (paused) {
                        player.play().then(() => console.log('Vimeo: avviato')).catch(err => console.error('Errore avvio:', err));
                    } else {
                        player.pause().then(() => console.log('Vimeo: in pausa')).catch(err => console.error('Errore pausa:', err));
                    }
                }).catch(err => console.error('Errore stato:', err));
            }
        }

        $wrapper.find('.play-video, .vimeo-video-place').off('click keydown').on('click keydown', function(e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            togglePlayer($wrapper);
            e.preventDefault();
        });

        $wrapper.find('.video__overlay').off('click').on('click', function(e) {
            togglePlayer($wrapper);
            e.preventDefault();
        });

        $wrapper.find('.mute-toggle').off('click keydown').on('click keydown', function(e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            e.stopPropagation();
            var player = $wrapper.data('player-instance');
            var $volumeOn = $(this).find('.volume-on');
            var $volumeOff = $(this).find('.volume-off');
            
            if (player) {
                // Controlla se l'icona volume-on è visibile per determinare lo stato attuale
                var isMuted = $volumeOn.hasClass('hidden');
                
                if (isMuted) {
                    // Attiva l'audio
                    player.setVolume(1);
                    $volumeOff.addClass('hidden');
                    $volumeOn.removeClass('hidden');
                } else {
                    // Disattiva l'audio
                    player.setVolume(0);
                    $volumeOn.addClass('hidden');
                    $volumeOff.removeClass('hidden');
                }
            }
        });

        $popupIcon.off('click keydown').on('click keydown', function(e) {
            if (e.type === 'keydown' && e.key !== 'Enter' && e.key !== ' ') return;
            console.log('Clic su popup-icon, data-src:', $(this).data('src'));
            if (typeof Fancybox !== 'undefined') {
                Fancybox.show([{
                    src: $(this).data('src'),
                    type: 'iframe',
                    // width: 1280,
                    // height: 720,
                    // aspect: aspectRatio // Passa il rapporto a Fancybox
                }], {
                    on: {
                        ready: (fancybox) => {
                            // Applica il data-aspect al fancybox__content
                            $('.fancybox__content').attr('data-aspect', aspectRatio);
                        },
                        close: () => { console.log('Popup Fancybox chiuso (manuale)'); }
                    }
                });
            }
            e.preventDefault();
        });

        if (autoStart) {
            const observerOptions = { root: null, threshold: 0.5 };
            const observer = new IntersectionObserver((entries, obs) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        togglePlayer($wrapper);
                        obs.unobserve(entry.target);
                    }
                });
            }, observerOptions);
            $wrapper.each(function() { observer.observe(this); });
        }
    });
});